import ItemListContainer from "../../components/ItemListContainer/ItemListContainer"

const Products = () => {
   return (
      <div>
         <ItemListContainer />
      </div>
   )
}

export default Products
